<!--table starts-->
<div class="modal-header align-items-center">
    <div class="">
        <img src="../../../../assets/images/call-ring.svg" width="30" alt="">
    </div>
    <h2 class="modal-title" translate>lblSearch<label class="text-white"> - {{callerInfoRequest.mobileNo}}</label></h2>
    <div class="col-auto ml-auto pr-0">
        <ul class="list-inline d-flex">
            <li class="d-flex align-items-center pr-3">
                <label>
                    <select class="text-white" (change)="onChangeDealer($event.currentTarget.value)">
                        <option *ngFor="let d of lstDealer" [value]="d.dealerId" class="text-dark">{{d.dealerName}}
                        </option>
                    </select>
                </label>
            </li>
            <li *ngIf="selectedDealer?.dealerName"><span class="ico-div mt-1"></span></li>
            <li *ngIf="isPbxEnabled">
                <button type="button" class="btn btn-ico mx-2" (click)="HangupCall(HangupContent)" autofocus="false"
                    ngbTooltip="{{ 'lblHangUp' | translate }}">
                    <em class="fas fa-phone-slash fa-lg font25 text-white"></em>
                </button>
            </li>
            <li><span class="ico-div mt-1"></span></li>
            <li>
                <button type="button" class="close btn btn-ico" aria-label="Close" (click)="OnMinimize(0)"
                    ngbTooltip="{{ 'lblHideCallerWindow' | translate }}">
                    <em class="fa fa-minus-square font22 text-white"></em>
                </button>
            </li>
            <li *ngIf="isPbxEnabled"><span class="ico-div mt-1"></span></li>
            <li>
                <button type="button" class="close btn btn-ico" aria-label="Close" (click)="OnClose(2)"
                    ngbTooltip="{{ 'lblClose' | translate }}">
                    <span aria-hidden="true">×</span>
                </button>
            </li>
            <li><span class="ico-div mt-1"></span></li>
            <li>
                <button type="button" class="close btn btn-ico pb-1" aria-label="Close" (click)="OnClose(1)"
                    ngbTooltip="{{ 'lblCloseAll' | translate }}">
                    <img src="../../../../assets/images/close-all-wh.svg" width="26" alt="">
                </button>
            </li>
        </ul>
    </div>
</div>

<div class="modal-body p-0 maxh85vh">
    <div class="card pad7x">
        <div [formGroup]="searchFilterForm" class="form-row">
            <div class="col-2">
                <label class="form-label" translate>lblRegNumber</label>
                <div class="d-flex input-group">
                    <input type="text" class="form-control" tabindex="1" formControlName="licensePlateNo"
                        (keyup.enter)="OnSearch('LicensePlate')" autocomplete="off">
                    <div class="input-group-append">
                        <button type="button" class="add-button btn btn-primary radius-lb-flat"
                            (click)="OnSearch('LicensePlate')"><em class="fa fa-search"></em></button>
                    </div>
                </div>
            </div>
            <div class="col-3 pl-4">
                <label class="form-label" translate>lblMobileNumber</label>
                <div class="d-flex input-group">
                    <input type="text" class="form-control" formControlName="mobileNo"
                        (keyup.enter)="OnSearch('Mobile')" autocomplete="off">
                    <div class="input-group-append">
                        <button type="button" class="add-button btn btn-primary radius-lb-flat"
                            (click)="OnSearch('Mobile')"><em class="fa fa-search"></em></button>
                    </div>
                    <div class="ml-2" *ngIf="isThirdPartyActive">
                        <button type="button" class="btn btn-primary" placement="top"
                            ngbTooltip="{{ 'lblDFSearch' | translate }}" (click)="OnDFSearch()">
                            <em class="fas">&#xf021;</em>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-2 pl-4">
                <label class="form-label" translate>lblSearchByCustomerName</label>
                <div class="d-flex input-group">
                    <input type="text" class="form-control" formControlName="customerName"
                        (keyup.enter)="OnSearch('Name')" autocomplete="off">
                    <div class="input-group-append">
                        <button type="button" class="add-button btn btn-primary radius-lb-flat"
                            (click)="OnSearch('Name')"><em class="fa fa-search"></em></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="pad5">
        <div class="card">
            <div class="pad5">
                <div class="card-header d-flex justify-content-between align-items-center pt-0">
                    <div class="font14 fontbold" translate>lblCustomer</div>
                    <button *ngIf="!hideAddButtons" type="button" class="btn btn-primary ml-auto" (click)="OnAddCustomer()" translate>
                        <em class="fa fa-plus mr-2"></em>lblAddCustomer
                    </button>
                </div>
                <div class="table-responsive max-vh20 p-0 border">
                    <table class="tablest1 fixed-header">
                        <thead>
                            <tr>
                                <th translate *ngIf="isMultipleCustomer">lblSelect</th>
                                <th translate>lblSource</th>
                                <th translate>lblCustomerNumber</th>
                                <th translate>lblName</th>
                                <th translate>lblAddress</th>
                                <th translate>lblMobile</th>
                                <th translate>lblEmail</th>
                                <th translate>lblCustomerGroup</th>
                                <th translate>lblCustomerType</th>
                                <th translate>lblIsActive</th>
                                <th translate>lblAction</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="lstCustomer?.length > 0; else load_else_customer">
                                <tr *ngFor="let c of lstCustomer; let i = index" [ngClass]="{'clrRed' : !c.isActive}">
                                    <td class="nowrap text-center vertical-middle" *ngIf="isMultipleCustomer">
                                        <input name="CustomerSelect" type="radio" class="radio-custom"
                                            (change)="OnCustomerSelect(c)" [value]="c.customerId"
                                            [disabled]="!c.isActive" *ngIf="c.source === 'Local' || c.source === 'CRM'"
                                            [checked]="c.isActive && ((c.source === 'Local' && selectedCustomer.customerId == c.customerId) || (c.source === 'CRM' && selectedCustomer.customerGuid == c.customerGuid))" />
                                    </td>
                                    <td class="nowrap">{{ c.source }}</td>
                                    <td class="nowrap">{{ c.customerNo }}</td>
                                    <td class="nowrap">{{ c.customerName }}</td>
                                    <td class="max-col-w200">
                                        <div [ngbTooltip]="tipContent" tooltipClass="long-tooltop">{{ c.addressLine1 }}
                                            {{ c.addressLine2 }}, {{ c.city }} {{ c.country }} {{ c.pinCode }}</div>
                                        <ng-template #tipContent>{{ c.addressLine1 }} {{ c.addressLine2 }}, {{ c.city }}
                                            {{ c.country }} {{ c.pinCode }}</ng-template>
                                    </td>
                                    <td class="nowrap">{{ c.mobileCode }} {{ c.customerMobile }}</td>
                                    <td class="nowrap">{{ c.customerEmail }}</td>
                                    <td class="nowrap">{{ c.customerGroup }}</td>
                                    <td class="nowrap">{{ c.customerType }}</td>
                                    <td class="text-center">
                                        <ng-container *ngIf="c.isActive; else load_else_isActive">
                                            <em class="fas fa-check"></em>
                                        </ng-container>
                                        <ng-template #load_else_isActive>
                                            <em class="fas fa-times text-danger cursordisable"
                                                *ngIf="c.source === 'Local'"></em>
                                        </ng-template>
                                    </td>
                                    <td>
                                        <a class="btn btn-ico" *ngIf="c.remark && (c.source === 'Local' || c.source === 'CRM')" [ngbTooltip]="customerRemarkContent" placement="auto" container="body"> <em class="fa fa-info fa-lg"></em> </a>
                                        <ng-template #customerRemarkContent> 
                                            <div class="text-left p-2" style="max-width: 400px;"> 
                                                <span> <b> <span translate> lblRemark</span>: </b> </span> <br>
                                                <span> {{ c.remark }} </span> 
                                            </div> 
                                        </ng-template>
                                        <a class="btn btn-ico" ngbTooltip="Edit" *ngIf="userRoleRightsDetails.canEdit && (c.source === 'Local' || (c.source === 'CRM' && c.customerId > 0))"
                                            (click)="viewCustomer(c)">
                                            <em class="fa fa-pencil-alt fa-lg"></em>
                                        </a>
                                        <a class="btn btn-ico" ngbTooltip="Add Customer"
                                            (click)="AddCustomerThroughVehicleSearch(c)"
                                            [hidden]="c.source === 'Local' || c.source === 'CRM'">
                                            <em class="fa fa-plus mr-2"></em>
                                        </a>
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-template #load_else_customer>
                                <tr>
                                    <td colspan="9" class="no-record" translate>lblNoRecordsFound</td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="pad5">
                <div class="card-header d-flex justify-content-between align-items-center pt-0">
                    <div class="font14 fontbold" translate>lblVehicles</div>
                    <button *ngIf="!hideAddButtons" type="button" class="btn btn-primary ml-auto" (click)="OnAddVehicle()" translate>
                        <em class="fa fa-plus mr-2"></em>lblAddVehicle
                    </button>
                </div>
                <div class=" table-responsive max-vh20 p-0 border">
                    <table class="tablest1 fixed-header">
                        <thead>
                            <tr>
                                <th translate>lblSource</th>
                                <th translate>lblRegNumber</th>
                                <th translate>lblVinNumber</th>
                                <th translate>lblRegistrationDate</th>
                                <th translate>lblNextInspectionDate</th>
                                <th translate>lblYear</th>
                                <th translate>lblFuelType</th>
                                <th translate>lblOwnerType</th>
                                <th translate>lblAction</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="lstVehicle?.length > 0; else load_else_vehicle">
                                <ng-container *ngFor="let v of lstVehicle">
                                    <tr>
                                        <td>{{ v.source }}</td>
                                        <td>
                                            <div class="flmid">
                                                <div class="licplate LPNo d-flex">
                                                    <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                                                    {{v.licensePlateNo}}
                                                </div>
                                                <div class="imgWid">
                                                    <ng-container>
                                                        <img af-brand-logo [data-code]="v.companyMakeCode" data-type="BRAND"
                                                            class="{{v.companyMakeCode}}-icon brandicon"
                                                            alt="{{v.companyMakeCode}}" />
                                                    </ng-container>
                                                </div>
                                            </div>
                                            <div class="mt-1">
                                                <ngb-highlight [result]="v.companyModel"
                                                    class="flmid semibold fs-12px lh-16px"></ngb-highlight>
                                            </div>
                                        </td>
                                        <td>{{ v.chassisNo }}</td>
                                        <td *ngIf="v.source === 'Local'">{{v.registrationDate | date:'shortDate'}} </td>
                                        <td *ngIf="v.source === 'Local'">{{v.inspectionNextDate | date:'shortDate'}}
                                        </td>
                                        <td *ngIf="v.source !== 'Local'">{{v.registrationDate}} </td>
                                        <td *ngIf="v.source !== 'Local'">{{v.inspectionNextDate}} </td>
                                        <td>{{ v.year }}</td>
                                        <td>{{ v.fuelType }}</td>
                                        <td>{{ v.ownerType }}</td>
                                        <td class="p-0 fix-col-70">
                                            <div *ngIf="v.source === 'Local' || v.source === 'CRM'" class="d-flex justify-content-end">
                                                <a class="btn btn-ico nowrap py-1" *ngIf="v.remark" [ngbTooltip]="vehicleRemarkContent" placement="auto" container="body"> <em class="fa fa-info fa-lg"></em> </a>
                                                <ng-template #vehicleRemarkContent> 
                                                    <div class="text-left p-2" style="max-width: 400px;"> 
                                                        <span> <b> <span translate> lblRemark</span>: </b> </span> <br>
                                                        <span> {{ v.remark }} </span> 
                                                    </div> 
                                                </ng-template>
                                                <button type="button" class="btn btn-sm btn-primary nowrap py-1 fa fa-plus mr-2" style="height: 25px;"
                                                    [disabled]="!selectedCustomer.isActive" ngbTooltip="Add Appointment"
                                                    (click)="selectedCustomer.isActive ? CheckDealerBrand(appointmentList,v.vehicleId, v.companyMakeCode, v.licensePlateNo) : return;"
                                                    translate>
                                                </button>
                                                <button *ngIf="v.source === 'Local' || (v.source === 'CRM' && v.vehicleId > 0)" type="button" class="btn btn-sm btn-primary nowrap py-1 fas fa-pencil-alt mr-2" style="height: 25px;"
                                                    [disabled]="!selectedCustomer.isActive" ngbTooltip="Edit Vehicle"
                                                    (click)="selectedCustomer.isActive ? EditVehicle(v) : return;"
                                                    translate>
                                                </button>
                                            </div>
                                            <button type="button" class="btn btn-sm btn-primary nowrap py-1 ml-auto"
                                                 *ngIf="v.isNewVehicle"
                                                 (click)="AddNewVehicle(v)"
                                                translate>
                                                <em class="fa fa-plus mr-2"></em>lblAddVehicle
                                            </button>
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                            <ng-template #load_else_vehicle>
                                <tr>
                                    <td colspan="7" class="no-record" translate>lblNoRecordsFound</td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="pad5">
                <div class="card-header d-flex justify-content-between align-items-center pt-0">
                    <div class="font14 fontbold" translate>lblCallHistory</div>
                </div>
                <div class="table-responsive max-vh20 p-0 border">
                    <table class="tablest1 fixed-header">
                        <thead>
                            <tr>
                                <th translate>lblCallFrom</th>
                                <th translate>lblCallTo</th>
                                <th translate>lblStartDateTime</th>
                                <th translate>lblEndDateTime</th>
                                <th translate>lblDuration</th>
                                <th translate>lblNote</th>
                                <th translate>lblAction</th>
                            </tr>
                        </thead>
                        <tbody class="main-panel">
                            <ng-container *ngIf="lstCallHistory?.length > 0; else load_else_calls">
                                <tr *ngFor="let c of lstCallHistory" [ngClass]="{'bg-highlight': c.callHistoryId === callerInfoRequest.callHistory.CallHistoryId
                            || c.callHistoryId === callerInfoRequest.callHistory.callHistoryId}">
                                    <td>{{ c.callFromNo }}</td>
                                    <td>{{ c.callToNo }}</td>
                                    <td>{{ c.callStartTime ? (getLocalDate(c.callStartTime) | date: "short") : '' }}
                                    </td>
                                    <td>{{ c.callEndTime ? (getLocalDate(c.callEndTime) | date: "short") : '' }}</td>
                                    <td>{{ getTimeDuration(c.callStartTime, c.callEndTime) }}</td>
                                    <td class="max-col-w120">
                                        <div class="text-truncate" container="body"
                                            [ngbTooltip]="(c.notes?.length > 40 ? tipContent : '')"
                                            tooltipClass="custom-revert note-tooltip">{{ c.notes }}</div>
                                        <ng-template #tipContent>{{c.notes?.length > 100 ? (c.notes | slice:0:100)+'..'
                                            : c.notes }}</ng-template>
                                    </td>
                                    <td>
                                        <a class="btn btn-ico" placement="left" (click)="OnAddNote(viewNoteContent, c)">
                                            <em class="fas fa-pencil-alt fa-lg"></em>
                                        </a>
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-template #load_else_calls>
                                <tr>
                                    <td colspan="6" class="no-record" translate>lblNoRecordsFound</td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Popup for call notes -->
<ng-template #viewNoteContent let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblNote</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"><span
                aria-hidden="true">×</span></button>
    </div>
    <div class="modal-body table-responsive">
        <form [formGroup]="callNotesForm" id="callNotes" (ngSubmit)="OnNoteSubmit()">
            <div class="row">
                <div class="col-12 af-form-group">
                    <textarea formControlName="notes" class="form-control" maxlength="1000" rows="8"
                        placeholder="{{ 'lblNote' | translate }}" required></textarea>
                    <div class="help-block float-right">{{cnf.notes.value ? cnf.notes.value?.length : 0}}/1000</div>
                    <div *ngIf="(cnf.notes.touched || isFormSubmitted) && cnf.notes.errors"
                        class="help-block text-danger">
                        <em class="fa fa-exclamation-circle" aria-hidden="true"></em>
                        <span translate>lblNoteRequired</span>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button form="callNotes" type="submit" class="btn btn-primary mr-sm-2 btn-md" translate>lblUpdate</button>
        <button type="button" class="btn btn-secondary btn-md" (click)="modal.close('Cancel click')"
            translate>lblCancel</button>
    </div>
</ng-template>
<!-- Popup for call hangup -->
<ng-template #HangupContent let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" (click)="modal.dismiss(true)" translate>lblHangUp</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(false)"><span
                aria-hidden="true">×</span></button>
    </div>
    <div class="modal-body table-responsive">
        <div class="row">
            <div class="col-12 af-form-group">
                <div class="help-block">
                    <em class="fa fa-exclamation-circle" aria-hidden="true"></em>
                    <span translate class="ml-2">lblHangUpConfirmMessage</span>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary mr-sm-2 btn-md" (click)="modal.dismiss(true)"
            translate>lblYes</button>
        <button type="button" class="btn btn-secondary btn-md" (click)="modal.dismiss(false)" translate>lblNo</button>
    </div>
</ng-template>
<!-- Popup for call transfer -->
<ng-template #TransferContent let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblTransfer</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(false)"><span
                aria-hidden="true">×</span></button>
    </div>
    <div class="modal-body table-responsive">
        <form [formGroup]="callTransferForm" id="callTransfer">
            <div class="row">
                <div class="col-12 af-form-group">
                    <input formControlName="destinationNo" class="form-control" (keyup.enter)="TransferCall(modal)"
                        placeholder="{{ 'lblDestinationNumber' | translate }}" required />
                    <div *ngIf="(ctf.destinationNo.touched || ctf.destinationNo.dirty) && ctf.destinationNo.errors"
                        class="help-block text-danger">
                        <em class="fa fa-exclamation-circle" aria-hidden="true"></em>
                        <span translate>lblDestinationNoRequired</span>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary mr-sm-2 btn-md" (click)="TransferCall(modal)"
            translate>lblTransfer</button>
        <button type="button" class="btn btn-secondary btn-md" (click)="modal.dismiss(false)"
            translate>lblCancel</button>
    </div>
</ng-template>
<!-- Popup for appointment list -->
<ng-template #appointmentList let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>
            PAY ATTENTION! <span class="small-txt">ALREADY PLANNED APPOINTMENT FOR THIS CAR</span>
        </h4>
        <button type="button" id="modelButton" class="close" aria-label="Center Align"
            (click)="modal.dismiss('Cross click');">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="width100">
        <div class="modal-body">
            <div class="row">
                <div class="col-12">
                    <button type="button" type="reset" id="closeBtn" aria-label="Center Align"
                        class="ml-3 add-button btn btn-primary float-right mb-3"
                        (click)="modal.dismiss('Cross click');CreateAppointment()" translate>lblAddAppointment</button>
                </div>
            </div>
            <div class="row">
                <div class="c12">
                    <div class="card mb-3">
                        <div class="card-header modal-title-cart d-flex  px-3" translate>
                            lblAppointment
                        </div>
                        <div class="table-responsive max-h260">
                            <table class="tablest1">
                                <thead>
                                    <tr>
                                        <th style="width:5%" scope="col" translate class="">lblType</th>
                                        <th style="width:8%" scope="col" translate>lblWoNo</th>
                                        <th style="width:20%" scope="col" translate>lblRegNumber
                                        </th>
                                        <th style="width:110px" scope="col" translate>lblSource</th>
                                        <th style="width:20%" class="ST" scope="col" translate>
                                            lblCustomer
                                        </th>
                                        <th style="width:20%" scope="col" translate>lblDealersName</th>
                                        <th style="width:5%" scope="col" translate class="text-center">lblStatus
                                        </th>
                                        <th style="width:7%" scope="col" translate>lblBookedDate</th>
                                        <th style="width:7%" scope="col" translate>lblCreatedDate</th>
                                        <th scope="col" style="width:150px" translate class="text-center">lblAction
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngIf="lstAppointment?.length>0; else load_else">
                                        <tr *ngFor="let appointment of lstAppointment; let i=index">
                                            <td>
                                                <ngb-highlight [result]="appointment.appointmentType"></ngb-highlight>
                                            </td>
                                            <td>
                                                <ngb-highlight [result]="appointment.workOrderNo"></ngb-highlight>
                                            </td>
                                            <td>
                                                <div class="flmid">
                                                    <div class="licplate LPNo d-flex">
                                                        <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                                                        {{appointment.licensePlate}}
                                                    </div>
                                                    <div class="imgWid">
                                                        <ng-container *ngIf="appointment.brandCode">
                                                            <img af-brand-logo [data-code]="appointment.brandCode"
                                                                data-type="BRAND"
                                                                class="{{appointment.brandCode}}-icon common"
                                                                [title]="appointment.brandCode" class="brandicon"
                                                                alt="img" />
                                                        </ng-container>
                                                    </div>
                                                </div>
                                                <div class="mt-1">
                                                    <ngb-highlight class="flmid semibold fs-12px lh-16px"
                                                        [result]="appointment.modelName"></ngb-highlight>
                                                </div>
                                            </td>
                                            <td>
                                                <ngb-highlight class="flmid sourceBox rounded-0 justify-content-center"
                                                    [result]="appointment.sourceCreation">
                                                </ngb-highlight>
                                            </td>
                                            <td>
                                                <ngb-highlight class="fs-16px semibold lh-18px d-block"
                                                    [result]="appointment.customerName">
                                                </ngb-highlight>
                                                <div class="d-flex align-items-center fs-12px mt-1 lh-16px">
                                                    <em _ngcontent-xdg-c220=""
                                                        class="fas fa-phone-flip fs-10px fa-lg mr-2 clr666"></em>
                                                    <span class="fs-12px"
                                                        *ngIf="appointment && appointment.mobileCode">+{{appointment.mobileCode}}-</span>
                                                    <ngb-highlight class="fs-12px" [result]="appointment.mobileNo">
                                                    </ngb-highlight>
                                                </div>

                                            </td>
                                            <td>
                                                <ngb-highlight [result]="appointment.dealerName"></ngb-highlight>
                                            </td>
                                            <td class="position-relative">
                                                <div class="mx-auto text-center">
                                                    <div class="color-box" [ngbTooltip]="appointment.appointmentStatus"
                                                        [style.background-color]="appointment.appointmentStatusColor">
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                {{ appointment.bookedDate | date:'short'}}
                                            </td>
                                            <td>
                                                {{ appointment.createdDateTime | date:'short'}}
                                            </td>
                                            <td>
                                                <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}"
                                                    (click)="EditAppointment(appointment.id)">
                                                    <em class="fas fa-pencil-alt fa-lg"></em>
                                                </a>
                                            </td>
                                        </tr>
                                    </ng-container>
                                    <ng-template #load_else>
                                        <tr>
                                            <td colspan="10" class="no-record" translate>lblNoRecordsFound</td>
                                        </tr>
                                    </ng-template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>